import React from 'react';
import { Tag } from 'antd';

const StatusIndicator = ({ status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Not Contacted':
        return 'default';  // Gray
      case 'Contacted':
        return 'green';    // Green for any contact
      default:
        return 'default';  // Gray for any unknown status
    }
  };

  return (
    <Tag color={getStatusColor(status)}>
      {status}
    </Tag>
  );
};

export default StatusIndicator;